module.exports = __webpack_public_path__ + "img/server.35194bc4.svg";